import {
  ISubscriptionAuthorizedPerson,
  ISubscriptionContactPersonBilling,
  ISubscription,
  ISubscriptionPropertyDetails,
  ISubscriptionInitialSelected,
} from '@pages/subscription/interfaces/form.interface';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState: ISubscription = {
  id: '',
  url: '',
  numberOfLicenses: 5,
  propertyDetails: {
    propertyName: '',
    address: {
      details: '',
      province: '',
      country: 'Philippines',
    },
    emailAddress: '',
    website: '',
    tin: '',
    phoneNumber: '',
  },
  authorizedPerson: {
    firstName: '',
    lastName: '',
    middleName: '',
    email: '',
    phoneNumber: '',
  },
  contactPersonBilling: {},
  // license: {
  //   numberOfUsers: 0,
  //   numberOfRooms: 0,
  //   concurrentUsers: 0,
  //   validity: 90,
  // },
  selectedProducts: [],
  sameAsAuthorized: true,
  plan: 'Monthly',
};

export const SubscriptionSlice = createSlice({
  name: 'subscription',
  initialState,
  reducers: {
    setSubscriptionID: (state, action: PayloadAction<string>) => ({
      ...state,
      id: action.payload,
    }),
    setSubscriptionURL: (state, action: PayloadAction<string>) => ({
      ...state,
      url: action.payload,
    }),
    setSubscriptionAuthorizedPerson: (
      state,
      action: PayloadAction<ISubscriptionAuthorizedPerson>,
    ) => ({
      ...state,
      authorizedPerson: action.payload,
    }),
    setSubscriptionContactPersonBilling: (
      state,
      action: PayloadAction<ISubscriptionContactPersonBilling>,
    ) => ({
      ...state,
      contactPersonBilling: action.payload,
    }),
    setSubscriptionProperty: (
      state,
      action: PayloadAction<ISubscriptionPropertyDetails>,
    ) => ({
      ...state,
      propertyDetails: {
        ...state.propertyDetails,
        ...action.payload,
        address: action.payload.address,
      },
    }),
    setSubscriptionNumberOfLicenses: (
      state,
      action: PayloadAction<number>,
    ) => ({
      ...state,
      numberOfLicenses: action.payload,
      license: {
        // ...state.license,
        numberOfUsers: action.payload * 10,
        numberOfConcurrentUsers: action.payload * 5,
      },
    }),
    setSubscriptionSameAsAuthorizedPerson: (
      state,
      action: PayloadAction<boolean>,
    ) => ({
      ...state,
      sameAsAuthorized: action.payload,
    }),
    setSubscriptionInitialSelected: (
      state,
      action: PayloadAction<ISubscriptionInitialSelected>,
    ) => ({ ...state, initialSelected: action.payload }),
    setSubscriptionReset: () => initialState,
  },
});

export default SubscriptionSlice.reducer;
export const {
  setSubscriptionID,
  setSubscriptionURL,
  setSubscriptionAuthorizedPerson,
  setSubscriptionContactPersonBilling,
  setSubscriptionProperty,
  setSubscriptionNumberOfLicenses,
  setSubscriptionSameAsAuthorizedPerson,
  setSubscriptionReset,
  setSubscriptionInitialSelected,
} = SubscriptionSlice.actions;
